import { createRouter, createWebHistory } from 'vue-router'
const Home = () => import('@/views/Home'/* webpackChunkName: "home" */)
const Record = () => import('@/views/Record'/* webpackChunkName: "record" */)
const Mine = () => import('@/views/Mine'/* webpackChunkName: "mine" */)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home,
    meta: { showTab: true }
  },
  {
    path: '/record',
    component: Record,
    meta: { showTab: true }
  },
  {
    path: '/mine',
    component: Mine,
    meta: { showTab: true }
  },
  { path: '/mybill', name: 'mybill', component: () => import('@/views/mine/MyBill.vue') },
  { path: '/privacy_policy', name: 'privacy_policy', component: () => import('@/views/mine/PrivacyPolicy.vue') },
  { path: '/user_agreement', name: 'user_agreement', component: () => import('@/views/mine/UserAgreement.vue') },
  { path: '/refund_policy', name: 'refund_policy', component: () => import('@/views/mine/RefundPolicy.vue') },
  { path: '/intellectual_property', name: 'intellectual_property', component: () => import('@/views/mine/IntellectualPropertyRights.vue') },
  { path: '/play/:id', name: 'play', component: () => import('@/views/Play.vue') },
  { path: '/search', name: 'search', component: () => import(/* webpackChunkName: "search" */ '@/views/Search.vue') },
  { path: '/login', name: 'login', component: () => import('@/views/mine/Login.vue') },
  { path: '/topup', name: 'topup', component: () => import('@/views/TopUp.vue') }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
